import { style } from 'constant/constants';
import { Grid, InputLabel, MenuItem, Select } from '@mui/material/index';
import PropTypes from 'prop-types';

const dropdownOptions = [{ name: 'Steel' }, { name: 'Copper' }, { name: 'Aluminum' }];

const SortDropdown = ({ setSortByMaterial, sortByMaterial }) => {
  const handleChange = (event) => {
    setSortByMaterial(event.target.value);
  };

  return (
    <Grid
      item
      xs={12}
      sx={{
        width: 400,
        height: 30,
        justifyContent: 'flex-end',
        alignItems: 'center'
      }}
      display="flex">
      <InputLabel
        htmlFor="demo-simple-select-label"
        sx={{
          fontFamily: style.fontFamily,
          color: style.LIGHT.primary,
          mt: 0,
          mr: 1,
          height: 20,
          alignItems: 'center'
        }}
        className="text-menu-color-green">
        Filter Selection
      </InputLabel>
      <Select
        value={sortByMaterial}
        size="small"
        sx={{ width: 120, fontFamily: style.fontFamily, mt: 0, mb: 0, height: 30 }}
        name="Material"
        onChange={handleChange}>
        {dropdownOptions?.length > 0 &&
          dropdownOptions.map((op) => (
            <MenuItem value={op.name} key={op.name} sx={{ fontFamily: style.fontFamily }}>
              {op.name}
            </MenuItem>
          ))}
      </Select>
      <InputLabel
        htmlFor="demo-simple-select-label"
        sx={{
          fontFamily: style.fontFamily,
          color: style.LIGHT.primary,
          mt: 0,
          ml: 1,
          mr: 1,
          height: 20,
          alignItems: 'center'
        }}
        className="text-menu-color-green">
        {/* to sort by price (in ascending order) */}
      </InputLabel>
    </Grid>
  );
};

export default SortDropdown;

SortDropdown.propTypes = {
  setSortByMaterial: PropTypes.func,
  sortByMaterial: PropTypes.string
};
